import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";

export const DiscountLine = ({ preview, options }: ComponentLineProps) => (
  <DefaultFullPreview.PreviewEntry
    label={t("paywall_checkout.coupon.discount")}
    value={preview?.future_payments?.formatted_discount}
    valueColor="text-green-700"
    tooltip={preview?.future_payments?.discount_phrase}
    dataTestId="checkout-form-preview-future-payments-discount"
    {...options}
  />
);
